import React, { useRef } from 'react';
import PackagingCanvas from './PackagingCanvas';
import ImageUpload from '../components/ImageUpload';
import SectionTitle from '../components/SectionTitle';
import { Close } from '../icons/Close';
import { LeftAlign } from '../icons/LeftAlign';
import { TopAlign } from '../icons/TopAlign';
import { BottomAlign } from '../icons/BottomAlign';
import { HorizontalCentreAlign } from '../icons/HorizontalCentreAlign';
import { VerticalCentreAlign } from '../icons/VerticalCentreAlign';
import { RightAlign } from '../icons/RightAlign';
import { SendToBack } from '../icons/SendToBack';
import { SendBack } from '../icons/SendBack';
import { BringForward } from '../icons/BringForward';
import { BringToFront } from '../icons/BringToFront';
import { handlise, moveElemInArray } from '../../helpers/utils';
import { HighlightCircle } from '../icons/HighlightCircle';
const ProductSide = ({ sideData, settings, filter, isActive, strings, uploadedImages, imageDimensions, imageSpecs, canvasDimensions, currentVariant, currentFilter, productOptions, handleImageUpload, handleImageRemove, handleAlignment, goToNextScreen, updateImageDimensions, updateImageScale, calculateCanvasSize, updatePosition, previewLoading, selectedImage, setSelectedImage, globalFolderName, currentSize, setImageUploading, reorderImagesOnSide, updateCurrentVariant, upsellItemsAreDifferentSizes, }) => {
    var _a;
    const canvasRef = useRef(null);
    const alignmentTools = {
        LeftAlign: {
            text: 'Left',
            component: LeftAlign,
        },
        RightAlign: {
            text: 'Right',
            component: RightAlign,
        },
        VerticalCentreAlign: {
            text: 'Vertical Centre',
            component: VerticalCentreAlign,
        },
        HorizontalCentreAlign: {
            text: 'Horizontal Centre',
            component: HorizontalCentreAlign,
        },
        TopAlign: {
            text: 'Top',
            component: TopAlign,
        },
        BottomAlign: {
            text: 'Bottom',
            component: BottomAlign,
        },
    };
    const layerTools = {
        SendDown: {
            text: 'Send Back',
            component: SendBack,
        },
        SendUp: {
            text: 'Bring Up',
            component: BringForward,
        },
        SendToBack: {
            text: 'Send to Back',
            component: SendToBack,
        },
        SendToTop: {
            text: 'Bring to Front',
            component: BringToFront,
        },
    };
    const reorderImages = (direction) => {
        let newUploadsOrder = uploadedImages;
        let newDimensionsOrder = imageDimensions;
        let imageIndex = selectedImage;
        if (selectedImage != null && isActive && uploadedImages.length > 1) {
            switch (direction) {
                case 'SendDown':
                    if (imageIndex != 0) {
                        newUploadsOrder = moveElemInArray(newUploadsOrder, imageIndex, imageIndex - 1);
                        newDimensionsOrder = moveElemInArray(newDimensionsOrder, imageIndex, imageIndex - 1);
                        imageIndex = imageIndex - 1;
                    }
                    break;
                case 'SendUp':
                    if (imageIndex != newUploadsOrder.length - 1) {
                        newUploadsOrder = moveElemInArray(newUploadsOrder, imageIndex, imageIndex + 1);
                        newDimensionsOrder = moveElemInArray(newDimensionsOrder, imageIndex, imageIndex + 1);
                        imageIndex = imageIndex + 1;
                    }
                    break;
                case 'SendToBack':
                    newUploadsOrder = moveElemInArray(newUploadsOrder, imageIndex, 0);
                    newDimensionsOrder = moveElemInArray(newDimensionsOrder, imageIndex, 0);
                    imageIndex = 0;
                    break;
                case 'SendToTop':
                    newUploadsOrder = moveElemInArray(newUploadsOrder, imageIndex, newUploadsOrder.length - 1);
                    // @ts-ignore
                    newDimensionsOrder = moveElemInArray(newDimensionsOrder, imageIndex, newDimensionsOrder.length - 1);
                    imageIndex = newUploadsOrder.length - 1;
                    break;
                default:
                    break;
            }
        }
        reorderImagesOnSide(newUploadsOrder, newDimensionsOrder);
        setSelectedImage(sideData.side_name, imageIndex);
    };
    return (React.createElement("div", { className: `hg-modal__side-customiser ${isActive ? 'active' : ''}` },
        React.createElement("div", { className: "hg-modal__product hg-modal__col-left" },
            React.createElement(PackagingCanvas, { side: sideData.side_name, settings: settings, sideImage: sideData.image, uploadedImages: uploadedImages || null, imageDimensions: imageDimensions, canvasDimensions: canvasDimensions, customiserWidth: canvasDimensions.widthMM + Number(sideData.canvas_left) + Number(sideData.canvas_right), customiserHeight: canvasDimensions.heightMM + Number(sideData.canvas_top) + Number(sideData.canvas_bottom), canvasTop: Number(sideData.canvas_top), canvasLeft: Number(sideData.canvas_left), packagingHeight: Number(sideData.packaging_height), packagingWidth: Number(sideData.packaging_width), canvasRef: canvasRef, updateImageDimensions: updateImageDimensions, updatePosition: updatePosition, setSelectedImage: setSelectedImage, selectedImage: selectedImage, calculateCanvasSize: calculateCanvasSize })),
        React.createElement("div", { className: "hg-modal__info hg-modal__col-right" },
            React.createElement("div", { className: "hg-modal__col-right--inner" },
                React.createElement("div", { className: "hg-modal__title-wrapper" },
                    React.createElement("h3", { className: "hg-modal__customise-title" }, strings.customise_title),
                    React.createElement("div", { className: "hg-modal__current-side" },
                        React.createElement("img", { src: sideData.icon_selected, alt: "" }),
                        React.createElement("p", null, sideData.side_name))),
                filter == 'Quantity' ? (React.createElement(React.Fragment, null,
                    React.createElement("h4", { className: "hg-modal__current-size" },
                        strings.selected_size_label,
                        React.createElement("span", { className: "hg-modal__current-size--size" }, currentSize)))) : null,
                filter == 'Colour' || filter == 'Color' ? (React.createElement("div", { className: "hg-modal__color-select" },
                    React.createElement(SectionTitle, { title: strings.color_label, titleSuffix: currentFilter }),
                    React.createElement("div", { className: "color-swatches" }, (_a = productOptions
                        .find((option) => option.name == 'Colour')) === null || _a === void 0 ? void 0 : _a.values.map((value, index) => (React.createElement("button", { className: `color-swatches__swatch${currentVariant.options.includes(value) ? ' selected' : ''}`, style: {
                            backgroundColor: value,
                            backgroundImage: `url(https://heapsgoodpackaging.com.au/cdn/shop/files/${handlise(value)}_50x50.png)`,
                        }, key: index, onClick: () => updateCurrentVariant(value) })))))) : null,
                React.createElement("div", { className: "hg-modal__image-specs" },
                    React.createElement(SectionTitle, { title: strings.upload_images_title, rightText: strings.upload_images_note }),
                    React.createElement("p", null, imageSpecs)),
                React.createElement(ImageUpload, { key: sideData.side_name, onUpload: handleImageUpload, uploadButton: strings.upload_btn, imageCount: uploadedImages.length, globalFolderName: globalFolderName, setImageUploading: setImageUploading, settings: settings }),
                React.createElement("div", { className: "hg-modal__uploaded-images-list" }, uploadedImages &&
                    uploadedImages.map((image, index) => {
                        let imageName = image.split('/').pop();
                        if (imageName.length > 20) {
                            imageName = imageName.slice(0, 20) + '...';
                        }
                        return (React.createElement("div", { className: "hg-modal__uploaded-image-item", key: index },
                            React.createElement("img", { src: image, alt: "Uploaded" }),
                            React.createElement("span", null, imageName),
                            React.createElement("button", { onClick: () => handleImageRemove(index, image, sideData.side_name) },
                                React.createElement(Close, null))));
                    })),
                React.createElement("div", { className: "hg-modal__image-tools" },
                    React.createElement(SectionTitle, { title: strings.image_edit_title }),
                    React.createElement("p", { className: "hg-modal__subheading" }, strings.align_btn),
                    React.createElement("div", { className: "hg-modal__image-tools--align" }, Object.keys(alignmentTools).map(function (key, index) {
                        const Icon = alignmentTools[key].component;
                        return (React.createElement("button", { className: "hg-modal__alignment-btn", key: index, onClick: () => handleAlignment(selectedImage, alignmentTools[key].text), disabled: selectedImage == null },
                            React.createElement(Icon, null),
                            alignmentTools[key].text,
                            React.createElement(HighlightCircle, null)));
                    })),
                    React.createElement("p", { className: "hg-modal__subheading" }, strings.layer_btn),
                    React.createElement("div", { className: "hg-modal__image-tools--layer" }, Object.keys(layerTools).map(function (key, index) {
                        const Icon = layerTools[key].component;
                        return (React.createElement("button", { className: "hg-modal__alignment-btn", key: index, "data-layer-tool": key, disabled: selectedImage == null, onClick: () => reorderImages(key) },
                            React.createElement(Icon, null),
                            layerTools[key].text,
                            React.createElement(HighlightCircle, null)));
                    })),
                    React.createElement("div", { className: "hg-modal__scale" },
                        React.createElement("p", { className: "hg-modal__subheading" }, strings.scale_btn),
                        React.createElement("label", { className: "hg-modal__scale--label" },
                            strings.width_label,
                            React.createElement("input", { type: "number", step: 0.01, min: 10, max: sideData.canvas_width, value: selectedImage != null ? imageDimensions[selectedImage].widthMM : 0, onChange: (event) => updateImageScale(selectedImage, 'width', Number(event.target.value)) })),
                        React.createElement("label", { className: "hg-modal__scale--label" },
                            strings.height_label,
                            React.createElement("input", { type: "number", step: 0.01, min: 10, max: sideData.canvas_height, value: selectedImage != null ? imageDimensions[selectedImage].heightMM : 0, onChange: (event) => updateImageScale(selectedImage, 'height', Number(event.target.value)) })))),
                React.createElement("button", { className: `hg-modal__next${previewLoading ? ' loading' : ''}`, onClick: goToNextScreen, disabled: previewLoading },
                    React.createElement("span", null, strings.next_btn),
                    React.createElement("div", { className: "next__spinner" }))))));
};
export default ProductSide;
